import { Dropdown } from "../elements";
import ajax from "../ajax";
export default {
  name: 'Locales',
  components: {
    Dropdown
  },
  data() {
    return {
      localeOptions: window.envs.availableLocales
    };
  },
  methods: {
    onLocaleChange
  }
};
function onLocaleChange(locale) {
  if (locale == this.$route.params.locale) {
    return;
  }
  if (!this.$i18n.messages[locale]) {
    [`${location.origin}/locale/${locale}`
    //`${window.envs.authTarget}/locale/${locale}`,
    ].unique().forEach(url => {
      ajax.get(url).then(response => {
        this.$i18n.mergeLocaleMessage(locale, response.data.content[locale]);
        this.$i18n.locale = locale;
      });
    });
  }
  let route = this.$route;
  this.$router.push({
    ...route,
    params: {
      ...route.params,
      locale
    }
  });
}